import httpService from "../httpService";

export default {
  findAllByCaseMasterId(caseMasterId) {
    let params = {caseMasterId: caseMasterId};
    return httpService.get(`/hcCaseHotelUserView/findAllByCaseMasterId`, {
      params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/khachsan/hcCaseHotelUserViewService.js